const translations = {
  BUTTONS: {
    '_goToPairing': 'Tovább a párosításhoz',
    '_downloadOutputFile': 'kimeneti fájl letöltés',
    '_nextPairing': 'Következő párosítás',
    '_startProcessing': 'Feldolgozás indítása',
    '_goToAccountAssignment': 'Tovább a kontírozáshoz',
    '_goToDownload': 'Tovább a letöltéshez',
    '_rules': 'Szabályok',
    '_savedPartners': 'Partnerek',
    '_downloadOutputFileBank': 'kimeneti fájl letöltés (Vevő)',
    '_downloadOutputFileBankCard': 'kimeneti fájl letöltés (Bankkártya)',
    '_downloadOutputFileCash': 'kimeneti fájl letöltés (Készpénz)',
    '_processing': 'Feldolgozás alatt...',
    '_back': 'Vissza',
    '_showProcessedItems': 'Feldolgozott tételek megjelenítése',
    '_hideProcessedItems': 'Feldolgozott tételek elrejtése',
    '_savePairing': 'Párosítás mentése',
    '_skipPairing': 'Párosítás kihagyása',
    '_startPayment': 'Fizetés indítása',
    '_save': 'Mentés',
    '_uploadRules': 'Feltöltése',
    '_delete': 'Törlés',
  },
  COMMON: {
    '_processingPleaseWait': 'Kimenet generálása folyamatban. Kérjük várja meg amíg a feldolgozás befejeződik.',
	'_downloadRules': 'Szabályok letöltése',
	'_uploadRules': 'Szabályokat tartalmazó XLSX fájl kiválasztása',
    '_printRules': 'Szabályok nyomtatása',
    '_deleteAllRules': 'Összes szabály törlése',
    '_processedSuccessfully': 'A feldolgozás sikeresen megtörtént.',
    '_rules': 'Szabályok',
    '_typeOfRule': 'Szabály típusa',
    '_position': 'Sorrend',
    '_finalRule': 'Végleges',
    '_temporarirlyRule': 'Egyszeri',
    _hu: 'Magyarországi',
    _non_eu: 'EU-n kívüli',
    _eu: 'EU-s',
    _editRuleText: 'Szabály szerkesztése',
    '_save': 'Mentés',
    '_close': 'Bezárás',
    '_noRulesFound': 'Ehez a céghez még nem lettek szabályok hozzárendelve.',
    '_bankRulesInfoText': 'Kérjük, csak azokat a mezőket töltse ki, melyek szeretné, hogy feltételként szolgáljanak a szabály alkalmazására.'
  },
  COD: {
    '_title': 'Utánvétlista',
    '_description': 'Kérjük, töltse fel a választott cég nyitott vevőit és szállítóit, valamint Partnertörzsét a könyvelőprogramjából. Majd a kontírozni kívánt időszakhoz és céghez tartozó Bankkivonatot. Amennyiben először használja a vállalkozásnál a programot, kérjük paraméterezze fel a modult könyvelt céghez kapcsolódó főkönyvi számokkal. ',
  },
  BANK: {
    '_buyerSupplierInputLabel': 'Töltsd fel a vevő/szállítói táblát',
    '_createdAt': 'Létrehozva',
    '_vszCompanyName': 'Parner neve a bankkivonaton',
    '_bankCompanyName': 'Partner neve a partnertörzsben',
    '_partnermaster': 'Partnertörzs',
	'_exchangemaster': 'Árfolyam',
    '_pleaseChooseOne': 'Kérjük válasszon',
    '_selectBankName': 'Banki kivonat típusa (kötelező)',
    '_selectedInvoicesSum': 'Kijelölt számlák összege',
    '_selectedTransfersSum': 'Kijelölt utalások összege',
    '_buyerSuppliersData': 'Vevő/szállító adatai',
    '_bank': 'Bank',
    '_partner': 'Partner',
    '_date': 'Dátum',
    '_description': 'Kérjük, töltse fel a választott cég nyitott vevőit és szállítóit, valamint Partnertörzsét a könyvelőprogramjából. Majd a kontírozni kívánt időszakhoz és céghez tartozó Bankkivonatot. Amennyiben először használja a vállalkozásnál a programot, kérjük paraméterezze fel a modult könyvelt céghez kapcsolódó főkönyvi számokkal. ',
    '_createRule': 'Szabály létrehozása és feldolgozása',
    '_oneTimeProcessing': 'Egyszeri feldolgozás',
    '_typeOfTraffic': 'Forgalom típusa',
    '_day': 'Értéknap',
    '_sum': 'Összeg',
    '_invoiceNumber': 'Számlaszám',
    '_companyName': 'Cég név',
    '_companyNameOffered': 'Találtatott cég',
    '_announcement': 'Közlemény',
    '_voucherNumber': 'Bizonylatszám',
    '_v_sz': 'V/SZ',
    '_mainBookNumber': 'Fők. szám',
	'_legalTitle': 'Jogcímkód',
    '_bankTransferDetails': 'Bank utalás adatai',
    '_bookingIntervall': 'Könyvelt időszak:',
    '_domesticBuyers': 'Töltsd fela belföldi vevőket és add meg a főkönyi számot',
    '_foreignBuyers': 'Töltsd fel a külföldi vevőket és add meg a főkönyvi számot',
    '_domesticSuppliers': 'Töltsd fel a belföldi szállítókat és add meg a főkönyvi számot',
    '_foreignSuppliers': 'Töltsd fel a külfödi szállítókat és add meg a főkönyvi számot',
	'_startBalance': 'Nyitó egyenleg',
	'_endBalance': 'Záró egyenleg',
    '_unknowItems': 'Azonosítatlan tételek könyvelése',
    '_bankLedgerNumber': 'Bank főkönyvi száma',
	'_bankAccountNumber': 'Banszámlaszám',
    '_mainData': 'Törzsadat',
    '_openBuyer': 'Belföldi nyitott vevő (opcionális)',
    '_openSupploer': 'Belföldi nyitott szállító (opcionális)',
    '_foreignOpenBuyer': 'Külföldi nyitott vevő (opcionális)',
    '_foreignOpenSupplier': 'Külföldi nyitott szállító (opcionális)',
    '_bankStatement': 'Banki kivonat (kötelező)',
	'_billNumber': 'Számlaszám',
  },
  CUSTOMER: {
    '_title': 'Számlázóprogramból kinyert NAV export kontírozása és könyvelése.',
    '_description': 'Kérjük, adja meg a kiválasztott cég főkönyvi struktúrájának megfelelő Főkönyvi számokat, majd töltse fel a kért adatokat a Számlázó programból és válassza ki az Ön által használt Könyvelőprogramot.',
    '_createRulesAndProcess': 'Szabály létrehozása és feldolgozása',
    '_oneTimeProcessing': 'Egyszeri feldolgozás',
    '_typeOfTraffic': 'Forgalom típusa',
    '_day': 'Értéknap',
    '_sum': 'Összeg',
    '_invoiceNumber': 'Számlaszám',
    '_companyName': 'Cég név',
    '_paymentType': 'Fiz. mód',
    '_announcement': 'Közlemény',
    '_v_sz': 'V/Sz',
    '_VAT': 'ÁFA kulcs',
    '_POSITION': 'Sorrend',
    '_collectorCode': 'Gyűjtő kód',
    '_mainBookNumber': 'Fők. szám',
	'_legalTitle': 'Jogcímkód',
    '_taxNumber': 'Adószám',
    '_vatDegreeNumber': 'ÁFA fők. szám',
    '_bookingIntervall': 'Könyvelt időszak:',
    'hufCashInvoicesRegistration': 'KÉSZPÉNZES FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfforgeingCurrenciesCashInvoices': 'KÉSZPÉNZES DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfTransferedHufInvoices': 'ÁTUTALÁSOS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfForgeinTransferedInvoices': 'ÁTUTALÁSOS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',

    'registrationNumberOfHufBankCardTransaction': 'BANKKÁRTYÁS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfBankCardTransaction': 'BANKKÁRTYÁS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfHufCodTransaction': 'UTÁNVÉTES FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfCodTransaction': 'UTÁNVÉTES DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfHufPayPalTransaction': 'PAYPAL-OS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfPayPalTransaction': 'PAYPAL-OS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',

    _rulesTitle: 'Szabályok szerkesztése',
    _partnersDeleteTitle: 'Mentett partnerek törlése',
    _rulesDescription: 'A kiválasztott céghez tartozó, korábbi kontírozások során mentett szabályok szerkesztése.',
    _editRule: 'Szerkesztés',
    _deleteRule: 'Törlés',
    _city: 'Város',
    _voucher_nb: 'Biz. szám',
    _startProcessingConfirmation: 'Biztos indítani szeretné a kontírozott tételek feldolgozásat?'
  },
  SUPPLIER: {
    '_title': 'Számlázóprogramból kinyert NAV export kontírozása és könyvelése.',
    '_description': 'Kérjük, adja meg a kiválasztott cég főkönyvi struktúrájának megfelelő Főkönyvi számokat, majd töltse fel a kért adatokat a Számlázó programból és válassza ki az Ön által használt Könyvelőprogramot.',
    '_createRulesAndProcess': 'Szabály létrehozása és feldolgozása',
    '_oneTimeProcessing': 'Egyszeri feldolgozás',
    '_typeOfTraffic': 'Forgalom típusa',
    '_day': 'Értéknap',
    '_sum': 'Összeg',
    '_invoiceNumber': 'Számlaszám',
    '_companyName': 'Cég név',
    '_paymentType': 'Fiz. mód',
    '_announcement': 'Közlemény',
    '_v_sz': 'V/Sz',
    '_VAT': 'ÁFA kulcs',
    '_POSITION': 'Sorrend',
    '_collectorCode': 'Gyűjtő kód',
    '_mainBookNumber': 'Fők. szám',
    '_legalTitle': 'Jogcímkód',
    '_taxNumber': 'Adószám',
    '_vatDegreeNumber': 'ÁFA fők. szám',
    '_bookingIntervall': 'Könyvelt időszak:',
    'hufCashInvoicesRegistration': 'KÉSZPÉNZES FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfforgeingCurrenciesCashInvoices': 'KÉSZPÉNZES DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfTransferedHufInvoices': 'ÁTUTALÁSOS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfForgeinTransferedInvoices': 'ÁTUTALÁSOS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',

    'registrationNumberOfHufBankCardTransaction': 'BANKKÁRTYÁS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfBankCardTransaction': 'BANKKÁRTYÁS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfHufCodTransaction': 'UTÁNVÉTES FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfCodTransaction': 'UTÁNVÉTES DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfHufPayPalTransaction': 'PAYPAL-OS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfPayPalTransaction': 'PAYPAL-OS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',

    _rulesTitle: 'Szabályok szerkesztése',
    _partnersDeleteTitle: 'Mentett partnerek törlése',
    _rulesDescription: 'A kiválasztott céghez tartozó, korábbi kontírozások során mentett szabályok szerkesztése.',
    _editRule: 'Szerkesztés',
    _deleteRule: 'Törlés',
    _city: 'Város',
    _voucher_nb: 'Biz. szám',
    _startProcessingConfirmation: 'Biztos indítani szeretné a kontírozott tételek feldolgozásat?'
  },
  CASHREGISTER: {

  },
  STEPS: {
    '_upload': 'Feltöltés',
    '_accountAssignment': 'Kontírozás',
    '_download': 'Letöltés',
  },
  LOGIN: {

  },
  COMPANY: {
    '_noCompaniesFoud': 'Nincs még cég hozzáadva.',
    '_bookedComaniesList': 'Könyvelt cégek listája.',
    '_name': 'Név',
    '_processedItemsCount': 'Kontírozott tételek',
    '_bookingIntervall': 'Könyvelt időszak',
    '_operations': 'Műveletek',
    '_addComapny': 'Cég hozzáadása',
    '_editComapny': 'Cég szerkesztése',
    '_save': 'Mentés',
    '_close': 'Bezárás'
  },
  PAGES: {
    PWDRESET: {

    },
    PRIVACY: {

    },
    TERMS: {

    }
  },
  VALIDATIONS: {
    '_startDateEndDate': 'Kezdő dátum nem lehet nagyobb mint a zárás dátum.'
  }
}
module.exports = translations


// WEBPACK FOOTER //
// ./src/i18/hu.js